import { makeStyles } from '@rneui/themed'
import React from 'react'
import { Animated, View } from 'react-native'

interface SkeletonProps {
  count?: number
}

export const EventSkeleton: React.FC<SkeletonProps> = ({ count = 3 }) => {
  const styles = useStyles()
  const animatedValue = React.useRef(new Animated.Value(0.3)).current

  React.useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.timing(animatedValue, {
          toValue: 1,
          duration: 1000,
          useNativeDriver: true,
        }),
        Animated.timing(animatedValue, {
          toValue: 0.3,
          duration: 1000,
          useNativeDriver: true,
        }),
      ])
    )
    animation.start()
    return () => animation.stop()
  }, [animatedValue])

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <Animated.View
          key={index}
          style={[
            styles.skeletonContainer,
            { opacity: animatedValue },
            index === 0 && styles.firstItem,
          ]}
        >
          <View style={styles.timeContainer}>
            <View style={styles.timeBlock} />
          </View>
          <View style={styles.contentContainer}>
            <View style={styles.titleBlock} />
            <View style={styles.subtitleBlock} />
          </View>
        </Animated.View>
      ))}
    </>
  )
}

const useStyles = makeStyles(theme => ({
  skeletonContainer: {
    flexDirection: 'row',
    padding: 16,
    backgroundColor: theme.colors.grey5,
    marginHorizontal: 16,
    marginVertical: 8,
    borderRadius: 8,
  },
  firstItem: {
    marginTop: 16,
  },
  timeContainer: {
    width: 60,
    marginRight: 16,
  },
  timeBlock: {
    height: 16,
    backgroundColor: theme.colors.grey4,
    borderRadius: 4,
  },
  contentContainer: {
    flex: 1,
  },
  titleBlock: {
    height: 20,
    backgroundColor: theme.colors.grey4,
    borderRadius: 4,
    marginBottom: 8,
    width: '80%',
  },
  subtitleBlock: {
    height: 16,
    backgroundColor: theme.colors.grey4,
    borderRadius: 4,
    width: '60%',
  },
}))
